

































































import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceItemViewModel from "../presenters/invoice-item-view-model";
import InvoiceRow from "./InvoiceRow.vue";
import VTd from "./VTd.vue";
import SelectOption from "../../../common/ui/presenters/select-option";

@Component({
  components: {
    VTd,
    InvoiceRow
  }
})
export default class InvoiceItem extends Vue {
  @Prop({ required: true }) item!: InvoiceItemViewModel;
  @Prop({ required: true }) unitOptions!: SelectOption[];

  calculate() {
    this.$emit("calculate");
  }
}
